import { BtnCheckboxDirectiveModule } from '@b2b/common/directives/btnCheckbox/btnCheckbox.directive';
import { CustomFieldsDirectiveModule } from '@b2b/common/directives/customFields/customFields.directive';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesControllerModule } from './controllers/TemplatesController';
import { TemplatesCreateView } from './create/create';
import { TemplatesReorderView } from './reorder/reorder';

export const TemplatesView = angular
  .module('acme.view.application.templates', [
    uiRouter,
    'ui.bootstrap',
    TemplatesControllerModule,
    TemplatesCreateView,
    TemplatesReorderView,
    CustomFieldsDirectiveModule,
    'acme.common.directive.numeric',
    'acme.common.directive.formInput',
    'acme.common.directive.upload',
    BtnCheckboxDirectiveModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates',
      url: '/templates',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'TemplatesController',
          templateUrl: 'views/application/views/templates/templates.tpl.html',
        },
      },
      data: {
        permissions: ['EVENT_TEMPLATE_CREATE', 'EVENT_TEMPLATE_UPDATE'],
      },
    });
  }).name;
